/**
 * The related column is the shared default from @evo-flywheel/ui (UI contract rule 13). The kit
 * supplies only what the shell cannot know: its descriptor set, which types have pages, and the
 * Italian labels of the relations it stores.
 */
import { configureRelatedRecords } from "@evo-flywheel/ui";
import { descriptors } from "@kit/descriptors/index";
import { kernel } from "../kernel";
import { resourceBySlug } from "../kit-resources";

/** Graph relations in the ai-portal kernel and the spine's own links, labelled in Italian. */
const EDGE_LABELS: Record<string, string> = {
  concerns: "Riguarda",
  journey_execution_id: "Esecuzione percorso",
  activity_id: "Attività",
  journey_id: "Percorso",
};

configureRelatedRecords({
  fetchKernel: (path) => kernel(path),
  descriptors: descriptors.map((d) => ({
    slug: d.slug,
    label: { singular: d.label.singular, plural: resourceBySlug[d.slug]?.meta.label ?? d.label.plural },
    relations: d.relations,
    icon: d.ui && typeof d.ui === "object" && "icon" in d.ui ? (d.ui.icon as string | undefined) : undefined,
  })),
  isRoutable: (slug) => Boolean(resourceBySlug[slug]),
  edgeLabel: (relation) => EDGE_LABELS[relation],
});
